import React, { useEffect, useState } from "react";
import UserCard from "../components/layout/UserCard";
import { getUser } from "../api/getUser";
import UserAchivments from "../components/layout/UserAchivments";
import UserTasks from "../components/layout/UserTasks";
import UserRanking from "../components/layout/UserRanking";

const LeaderboardPage = () => {
  const [data, setdata] = useState();
  useEffect(() => {
    getData();
  }, []);
  async function getData() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      window.location.href = window.origin;
    }
    const res = await getUser(user._id);
    setdata(res);
  }

  return (
    <div className="w-full py-6 text-white">
      <UserRanking data={data} />
    </div>
  );
};

export default LeaderboardPage;
